exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-74420e07] .el-card__body{height:100%}", ""]);

// exports
